import React, { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import UseContext from "hooks/useContext";
import SlideOverStructure from "../component/structure";
import DataSlideOver from "../dataSlideOver";
import { INVOICE_DETAIL_SLIDE_OVER } from "components/invoiceDetail/useOpenInvoiceDetail";
import { APPOINTMENT_PANEL } from "hooks/useAppointmentPanel";
import { RECORD_FORM_PANEL } from "hooks/useRecordPanels";
import { TASK_FORM_PANEL, TASK_PANEL } from "hooks/useTaskPanels";
import { CREATE_MENU_PANEL } from "components/sidebar/CreateMenuPanel";
import { MENTIONS_PANEL } from "components/home/MentionsPanel";
import { REVIEW_PANEL } from "components/stats/ReviewPanel";
import { EDIT_COMPANY_PANEL } from "components/companies/CompanyEditPanel";
import { NARROW_SLIDE_OVER_WIDTH, SlideOverWidthContext } from "../wideSlideOver";

// Panels wider than the default 800 px: the invoice detail shows its PDF
// beside its information (JBWEB-1274).
const PANEL_WIDTHS = {
    [INVOICE_DETAIL_SLIDE_OVER]: 'lg:w-[1200px]',
    // A task reads as a column: its panel and its form stay narrow.
    [TASK_PANEL]: NARROW_SLIDE_OVER_WIDTH,
    [TASK_FORM_PANEL]: NARROW_SLIDE_OVER_WIDTH,
    [RECORD_FORM_PANEL]: NARROW_SLIDE_OVER_WIDTH,
    [APPOINTMENT_PANEL]: NARROW_SLIDE_OVER_WIDTH,
    [CREATE_MENU_PANEL]: NARROW_SLIDE_OVER_WIDTH,
    [MENTIONS_PANEL]: NARROW_SLIDE_OVER_WIDTH,
    [REVIEW_PANEL]: NARROW_SLIDE_OVER_WIDTH,
    [EDIT_COMPANY_PANEL]: NARROW_SLIDE_OVER_WIDTH,
};

const Index = () => {
    const {slideOverShow, slideOverType} = UseContext()
    // A panel asks for another width while it is shown (useSlideOverWidth):
    // the week beside its form, the payment settings of a company.
    const [widthOverride, setWidthOverride] = useState(null);
    const width = widthOverride ?? PANEL_WIDTHS[slideOverType];
    const [showCV, setShowCV] = useState(false);

    // Réinitialiser showCV quand le slideOver se ferme ou change de type
    useEffect(() => {
        if (!slideOverShow || slideOverType !== 'get_temp_worker') {
            setShowCV(false);
        }
    }, [slideOverShow, slideOverType]);

    if(!slideOverShow) return null

    return ReactDOM.createPortal(
        <SlideOverStructure isShowing={slideOverShow} showCV={showCV && slideOverType === 'get_temp_worker'} width={width}>
            <SlideOverWidthContext.Provider value={setWidthOverride}>
                <DataSlideOver setShowCV={setShowCV} />
            </SlideOverWidthContext.Provider>
        </SlideOverStructure>
        , document.getElementById('root-portal'));
};

export default Index;